export enum BackgroundInfoType {
  Dfci = 'dfci',
  LevelCurves = 'levels',
  SidePoints = 'side_points',
}
